var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "quick-actions-card" }, [
    _c(
      "div",
      {
        staticClass: "quick-actions-header",
        attrs: { slot: "header" },
        slot: "header",
      },
      [
        _c("i", { staticClass: "el-icon-lightning" }),
        _vm._v(" "),
        _c("span", [_vm._v("快捷操作")]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "quick-actions-grid" }, [
      _c(
        "div",
        {
          staticClass: "action-item",
          on: {
            click: function ($event) {
              return _vm.$emit("quick-add")
            },
          },
        },
        [
          _c("div", { staticClass: "action-icon add" }, [
            _c("i", { staticClass: "el-icon-plus" }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "action-content" }, [
            _c("div", { staticClass: "action-title" }, [_vm._v("快速新增")]),
            _vm._v(" "),
            _c("div", { staticClass: "action-desc" }, [_vm._v("添加新工会")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "action-item",
          on: {
            click: function ($event) {
              return _vm.$emit("bulk-import")
            },
          },
        },
        [
          _c("div", { staticClass: "action-icon import" }, [
            _c("i", { staticClass: "el-icon-upload" }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "action-content" }, [
            _c("div", { staticClass: "action-title" }, [_vm._v("批量导入")]),
            _vm._v(" "),
            _c("div", { staticClass: "action-desc" }, [
              _vm._v("Excel批量导入"),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "action-item",
          on: {
            click: function ($event) {
              return _vm.$emit("export-all")
            },
          },
        },
        [
          _c("div", { staticClass: "action-icon export" }, [
            _c("i", { staticClass: "el-icon-download" }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "action-content" }, [
            _c("div", { staticClass: "action-title" }, [_vm._v("导出数据")]),
            _vm._v(" "),
            _c("div", { staticClass: "action-desc" }, [_vm._v("导出所有工会")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "action-item",
          on: {
            click: function ($event) {
              return _vm.$emit("view-stats")
            },
          },
        },
        [
          _c("div", { staticClass: "action-icon stats" }, [
            _c("i", { staticClass: "el-icon-data-analysis" }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "action-content" }, [
            _c("div", { staticClass: "action-title" }, [_vm._v("数据统计")]),
            _vm._v(" "),
            _c("div", { staticClass: "action-desc" }, [_vm._v("查看详细统计")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "action-item",
          on: {
            click: function ($event) {
              return _vm.$emit("settings")
            },
          },
        },
        [
          _c("div", { staticClass: "action-icon settings" }, [
            _c("i", { staticClass: "el-icon-setting" }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "action-content" }, [
            _c("div", { staticClass: "action-title" }, [_vm._v("系统设置")]),
            _vm._v(" "),
            _c("div", { staticClass: "action-desc" }, [_vm._v("配置管理")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "action-item",
          on: {
            click: function ($event) {
              return _vm.$emit("help")
            },
          },
        },
        [
          _c("div", { staticClass: "action-icon help" }, [
            _c("i", { staticClass: "el-icon-question" }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "action-content" }, [
            _c("div", { staticClass: "action-title" }, [_vm._v("使用帮助")]),
            _vm._v(" "),
            _c("div", { staticClass: "action-desc" }, [_vm._v("操作指南")]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }